interface IParseUserInitialsParams {
    forename?: string | undefined;
    surname?: string | undefined;
    displayName?: string | undefined;
}

export function ParseUserInitials(params: IParseUserInitialsParams) {
    let initials = '';

    if(params.displayName) {
        const split = params.displayName.split(' ');
        if(split.length > 0) initials += split[0][0];
        if(split.length > 1) initials += split[1][0];
    } else {
        if(params.forename) initials += params.forename![0];
        if(params.surname) initials += params.surname![0];
    }
    return initials;
}